"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _main = _interopRequireDefault(require("../templates/main"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

var ARROW_RIGHT_KEY = 39,
    ARROW_LEFT_KEY = 37,
    BACKSPACE_KEY = 8,
    DELETE_KEY = 46,
    nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main() {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isDisabled", function (id) {
      var lastAvailable = _this._getLastAvailableCell(),
          cells = [],
          i = 0;

      for (i; i < _this.props.count; i++) {
        cells.push(_this.id + i);
      }

      return cells.indexOf(lastAvailable) < cells.indexOf(id);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleCellChange", function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var target = event.target,
          value = target.value,
          selectionEnd = target.selectionEnd,
          id = target.id,
          prevCellsValue = _this._prevCellValue(id),
          availRestLength;

      if (typeof _this.props.cellFormat === 'function') {
        value = _this.props.cellFormat(value);
      } // TODO REMOVE


      if (typeof _this.props.ceilFormat === 'function') {
        value = _this.props.ceilFormat(value);
      }

      availRestLength = _this._getAvailableRestLength(id); // нет свободных ячеек, следующих за текущей, и значение текущей заполнено
      // вставка не возможна

      if (availRestLength === 0 && value.length > _this.props.maxLength) {
        return (0, _assertThisInitialized2["default"])(_this);
      }

      _this.carriagePosition = prevCellsValue.length + selectionEnd;

      _this._updateCell(id, value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handlePaste", function (event) {
      event.preventDefault();

      var target = event.target,
          selectionEnd = target.selectionEnd,
          selectionStart = target.selectionStart,
          id = target.id,
          value = target.value,
          availRestLength = _this._getAvailableRestLength(id),
          pastedValue = event.clipboardData.getData('Text');

      if (typeof _this.props.cellFormat === 'function') {
        pastedValue = _this.props.cellFormat(pastedValue);
      } // TODO REMOVE


      if (typeof _this.props.ceilFormat === 'function') {
        pastedValue = _this.props.ceilFormat(pastedValue);
      } // + количество незаполненных символов в текущей ячейке


      availRestLength += _this.props.maxLength - value.length; // + символы которые будут заменены после выделения

      availRestLength += selectionEnd - selectionStart;

      if (availRestLength > 0) {
        // обрезаем значение из буфера под количество доступных ячеек
        pastedValue = pastedValue.substr(0, availRestLength); // удаляем символы из выделения

        value = value.replace(value.substring(selectionStart, selectionEnd), '');
        value = // символы которые не были затронуты (до выделения)
        value.substring(0, selectionStart) + // отформатированное значение из буфера
        pastedValue + // остаток символов после значения из буфера
        value.substring(selectionStart); // нативное событие получит отформатированный ввод, и отработает с ним как нужно

        nativeInputValueSetter.call(target, value);
        target.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }

      if (typeof _this.props.onPaste === 'function') {
        _this.props.onPaste(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleCellKeyDown", function (event) {
      var keyCode = event.keyCode,
          target = event.target,
          selectionStart = target.selectionStart,
          selectionEnd = target.selectionEnd,
          id = target.id; // backspace and delete key
      // must remove last digit in previous cell

      if (keyCode === BACKSPACE_KEY && selectionStart === 0 && selectionEnd === 0) {
        event.preventDefault();

        var prevCells = _this._prevCells(id);

        if (prevCells.length) {
          var last = prevCells[prevCells.length - 1],
              prevCellValue,
              restValue;
          restValue = _this._prevCellValue(last);
          prevCellValue = _this.state[last] || '';
          prevCellValue = prevCellValue.substring(0, prevCellValue.length - 1);
          _this.carriagePosition = (restValue + prevCellValue).length;

          _this._updateCell(last, prevCellValue);
        } // delete key in end of filled cell without selection

      } else if (keyCode === DELETE_KEY && selectionStart === selectionEnd && selectionEnd === _this.props.maxLength) {
        event.preventDefault();

        var nextCells = _this._nextCells(id);

        if (nextCells.length) {
          var next = nextCells[0],
              nextCellValue = _this.state[next] || '';

          if (nextCellValue) {
            // start of next cell
            _this.carriagePosition = _this._prevCellValue(next).length;

            _this._updateCell(next, nextCellValue.substr(1));
          }
        }
      } else if (keyCode === ARROW_RIGHT_KEY && selectionStart === _this.props.maxLength) {
        event.preventDefault();

        _this._focusRight();
      } else if (keyCode === ARROW_LEFT_KEY && selectionStart === 0) {
        event.preventDefault();

        _this._focusLeft();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateCellValue", function (id, value) {
      return _this.setState((0, _defineProperty2["default"])({}, id, value));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getLastAvailableCell", function () {
      var value = _this._prepareValue(_this.props.value);

      var lastAvailCell = 0;

      if (value && value.length) {
        // count starts with 0
        lastAvailCell = Math.floor(value.length / _this.props.maxLength);
        lastAvailCell = lastAvailCell === _this.props.count ? lastAvailCell - 1 : lastAvailCell;
      }

      return _this.id + lastAvailCell;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getAvailableRestLength", function (after) {
      var nextCells = _this._nextCells(after),
          nextCellsValue = _this._nextCellValue(after);

      return nextCells.length * _this.props.maxLength - nextCellsValue.length;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_moveCarriage", function () {
      var activeElement, cellPosition, selectionPosition; // raw cell position for next selection

      cellPosition = _this.carriagePosition / _this.props.maxLength;

      if (_this.carriagePosition < _this.props.count * _this.props.maxLength) {
        selectionPosition = _this.carriagePosition - Math.floor(cellPosition) * _this.props.maxLength;
      } else {
        selectionPosition = _this.props.maxLength;
      } // if next position out of count length - set last


      if (cellPosition === _this.props.count) {
        cellPosition -= 1; // if cell is not fully filled
      } else if (cellPosition % 1 !== 0) {
        cellPosition = Math.floor(cellPosition);
      }

      activeElement = _this._inputRefs[_this.id + cellPosition];

      if (activeElement && activeElement !== window.document.activeElement) {
        activeElement.focus();
      }

      _this._setSelection(activeElement, selectionPosition, selectionPosition);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_prepareValue", function (value) {
      if (typeof value === 'string') {
        return value;
      } else if (typeof value === 'number' && !isNaN(value)) {
        return String(value);
      } else {
        return '';
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_prevCellValue", function (before) {
      return _this._prevCells(before).reduce(function (memo, id) {
        return memo += _this.state[id] || '';
      }, '');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_nextCellValue", function (after) {
      return _this._nextCells(after).reduce(function (memo, id) {
        return memo += _this.state[id] || '';
      }, '');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_prevCells", function (before) {
      return _this._cellIds(null, before);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_nextCells", function (after) {
      return _this._cellIds(after);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleHover", function () {
      return _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleRootBlur", function () {
      return _this.setState({
        hover: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleCellFocus", function (event) {
      var target = event.target,
          id = target.id;

      _this.setState({
        focus: id
      });

      if (_this._isDisabled(id)) {
        var available = _this._getLastAvailableCell(),
            element = _this._inputRefs[available],
            nextValue = _this.state[available];

        _this._moveFocus(target, element, nextValue.length, nextValue.length);
      }

      if (typeof _this.props.onFocus === 'function') {
        _this.props.onFocus(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleCellBlur", function (event) {
      var cells = _this._inputRefs ? Object.keys(_this._inputRefs) : [],
          activeElement = window.document.activeElement,
          needBlur = !cells.find(function (item) {
        return item === activeElement;
      }),
          onResolve = function onResolve() {
        if (typeof _this.props.onBlur === 'function') {
          _this.props.onBlur(event);
        }
      };

      if (_this.state.focus && needBlur) {
        _this.setState({
          focus: null
        }).then(function () {
          return onResolve(event);
        });
      } else {
        onResolve(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_focusRight", function () {
      if (_this.state.focus && document.activeElement) {
        var current = document.activeElement.id,
            nextCells = _this._nextCells(current);

        if (nextCells.length) {
          var nextId = nextCells[0],
              nextInput = _this._inputRefs[nextId],
              nextValue = _this.state[nextId];

          if (!_this._isDisabled(nextId)) {
            _this._moveFocus(document.activeElement, nextInput, nextValue.length, nextValue.length);
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_focusLeft", function () {
      if (_this.state.focus && document.activeElement) {
        var current = document.activeElement.id,
            prevCells = _this._prevCells(current);

        if (prevCells.length) {
          var prevId = prevCells[prevCells.length - 1],
              prevInput = _this._inputRefs[prevId],
              prevValue = _this.state[prevId];

          _this._moveFocus(document.activeElement, prevInput, prevValue.length, prevValue.length);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_moveFocus", function (prevEl, nextEl, selectionStart, selectionEnd) {
      // for correct transition between inputs
      prevEl.blur(); // setState collapse states or smt else, we need timeout here for correct work

      setTimeout(function () {
        return nextEl.focus();
      }, 0);

      _this._setSelection(nextEl, selectionStart, selectionEnd);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_makeInputRef", function (el) {
      if (el) {
        _this._inputRefs[el.id] = el;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_externalRef", function (el) {
      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(el);
      }
    });
    _this.state = {
      hover: false,
      focus: null
    };
    _this.id = (0, _uniqueId["default"])('separated_input');
    _this._inputRefs = {};
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._externalRef(this);

      this.value = this.props.value;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Main.prototype), "componentWillUnmount", this).call(this);

      this._externalRef(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.value = this.props.value;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var availableCell = this._getLastAvailableCell();

      if (availableCell && this._inputRefs && this._inputRefs[availableCell]) {
        this._inputRefs[availableCell].focus();
      }
    }
  }, {
    key: "_dispatchSyntheticEvent",
    value: function _dispatchSyntheticEvent() {
      var target = {
        value: this.value,
        type: 'input',
        name: this.props.name
      };

      if (typeof this.props.onChange === 'function') {
        this.props.onChange((0, _syntheticEvent["default"])(target));
      }

      return Promise.resolve();
    }
    /**
     * cell not available for filling
     * @param {String} id - cell ID
     * @return {boolean}
     * @private
     */

  }, {
    key: "_updateCell",
    value: function _updateCell(id, value) {
      var _this2 = this;

      this._updateCellValue(id, value).then(function () {
        return _this2._dispatchSyntheticEvent();
      }).then(function () {
        return _this2._moveCarriage();
      });
    }
  }, {
    key: "_setSelection",
    value: function _setSelection(el, start, end) {
      if (el.setSelectionRange) {
        try {
          el.setSelectionRange(start, end);
        } catch (e) {}
      }

      return el;
    }
  }, {
    key: "_cellIds",

    /**
     * Returns cells range
     * @param {String} startAfter - range start
     * @param {String} endBefore - range end
     * @return {Array} ids
     * @private
     */
    value: function _cellIds(startAfter, endBefore) {
      var i = 0,
          started = !startAfter;
      var len = this.props.count,
          result = [];

      for (i; i < len; i++) {
        var id = this.id + i;

        if (id === endBefore) {
          break;
        }

        if (started && this._inputRefs[id]) {
          result.push(id);
        } else {
          started = id === startAfter;
        }
      }

      return result;
    }
  }, {
    key: "value",
    get: function get() {
      var value = '',
          i = 0,
          len = this.props.count;

      for (i; i < len; i++) {
        value += this.state[this.id + i] || '';
      }

      value = value.substr(0, this.props.maxLength * this.props.count);
      return value;
    },
    set: function set(value) {
      value = this._prepareValue(value);
      var i = 0,
          len = this.props.count,
          state = {};

      for (i; i < len; i++) {
        var id = this.id + i,
            start = this.props.maxLength * i;
        state[id] = value.substr(start, this.props.maxLength);
      }

      this.setState(state);
      return value;
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  type: 'tel',
  label: '',
  placeholder: 'XX',
  count: 4,
  maxLength: 2,
  onChange: null,
  onBlur: null,
  onFocus: null,
  wide: false,
  autoComplete: 'off'
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  autoComplete: _propTypes["default"].string,

  /**
   * type of native input
   */
  type: _propTypes["default"].string,
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,

  /**
   * count of inputs
   */
  count: _propTypes["default"].number,

  /**
   * input length
   */
  maxLength: _propTypes["default"].number,
  cellFormat: _propTypes["default"].func,

  /**
   * onChange callback
   */
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,

  /**
   * 100% width
   */
  wide: _propTypes["default"].bool,
  value: _propTypes["default"].any,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.twNormal
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    placeholder: _propTypes["default"].string,

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    paddingBottom: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tLabel
     */
    labelColor: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tFilled
     */
    idleColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    idlePlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    idleLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    idleBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    idleBorderStyle: _propTypes["default"].string,

    /**
     * @default 1px
     */
    idleBorderWidth: _propTypes["default"].string,

    /**
     * @default scale(0)
     */
    idleBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    idleBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    idleBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    idleBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    idleOutline: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    focusColor: _propTypes["default"].string,

    /**
     * @default palette.tPlaceholder
     */
    focusPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    focusLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    focusBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    focusBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    focusBorderWidth: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    focusBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    focusBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    focusBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    focusBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    focusOutline: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    hoverPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    hoverLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elSecondary
     */
    hoverBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    hoverBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    hoverBorderWidth: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    hoverBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    hoverBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverOutline: _propTypes["default"].string,

    /**
     * @default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    disabledLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tPlaceholder
     */
    disabledPlaceholder: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    disabledBorderTransform: _propTypes["default"].string,

    /**
     * @default none none dotted
     */
    disabledBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    disabledBorderWidth: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    disabledBorderColor: _propTypes["default"].string,

    /**
     * @default 0
     */
    disabledBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    disabledBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    disabledBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    disabledOutline: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    errorColor: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    errorPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.elError
     */
    errorBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    errorBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    errorBorderWidth: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    errorBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    errorBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    errorBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    errorBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    errorOutline: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'SeparatedInput');
var _default = Main;
exports["default"] = _default;